const PrerenderService = {
  managedByRoute: false,

  markNotReady() {
    this.managedByRoute = true;
    window.prerenderReady = false;
  },

  markReady() {
    window.prerenderReady = true;
  },

  // Mark ready AFTER the browser has painted, so react-helmet has flushed the
  // page's <title>/<meta> into the document head before prerender.io snapshots.
  // react-helmet commits head changes on its own animation frame; deferring two
  // frames guarantees we run after that. Use this for routes whose <title>/h1
  // render synchronously (no async data) but still lose the race to a plain
  // markReady() called in componentDidMount.
  markReadyAfterPaint() {
    window.requestAnimationFrame(() =>
      window.requestAnimationFrame(() => this.markReady()),
    );
  },

  markReadyIfNotManaged() {
    if (!this.managedByRoute) {
      window.prerenderReady = true;
    }
  },
};

export default PrerenderService;
